import { render } from "./RotateFrame.vue?vue&type=template&id=09d8d5f4&scoped=true"
import script from "./RotateFrame.vue?vue&type=script&lang=js"
export * from "./RotateFrame.vue?vue&type=script&lang=js"

import "./RotateFrame.vue?vue&type=style&index=0&id=09d8d5f4&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-09d8d5f4"]])

export default __exports__